// TODO - надо обновить бутстрап и отказаться от jQuery
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.js';


import SwiperEffectVideoElement from 'modules/widget/swiper/video-effect';
import Swiper, { Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/grid';
import 'swiper/scss/scrollbar';

export default class SwiperVideoWidget {
    _slider;

    _objSlider;

    _classSlider;

    _classSliderItem;

    constructor(opts = {}) {
        this._slider = null;
        this._objSlider = null;
        this._classSlider = opts.classSlider || '.js-swiper-video';
        this._classSliderItem = opts.classSlider || '.js-swiper-video-item';
    }

    _createSlider(){
        this._objSlider = document.querySelector(this._classSlider);
        if (!this._slider && this._objSlider) {
            this._slider = new Swiper(this._classSlider, {
                modules: [Pagination, SwiperEffectVideoElement],
                effect: "carousel",
                loop: true,
                slidesPerView: "auto",
                slideToClickedSlide: true,
                on: {
                    slideChange: (ev) => {
                        console.log('slide changed');
                        this._initSlideClick();
                    },
                }
            });

            this._createModal();
            this._initSlideClick();
            this._destroyModal();

            console.log('Slider Video init');
        } else {
            console.log('Error Slider Video init');
        }
    }

    _createModal(){
        const html = `<div class="new-modal fade" id="blockSwiperVideoSliderModal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="new-modal-dialog new-modal-dialog-video" role="document">
                            <div class="new-modal-content">
                                <a class="new-modal-close" data-dismiss="modal" aria-label="Close"></a>
                                <div class="new-modal-video" id="blockSwiperVideoSliderModal_content">

                                </div>
                            </div>
                        </div>
                    </div>`;
        this._objSlider.insertAdjacentHTML(
            'afterend',
            html
        );
    }

    _initSlideClick() {
        if (!this._slider && this._objSlider) {
            const swiperItems = this._objSlider.querySelectorAll(this._classSliderItem);
            swiperItems.forEach((item) => {
                if (!item.classList.contains('init')){
                    item.classList.add('init');
                    item.addEventListener("click", () => {
                        // TODO - надо обновить бутстрап и отказаться от jQuery
                        $('#blockSwiperVideoSliderModal').modal('show');
                        this._openModal(item.dataset.video, item.dataset.type);
                    });
                }
            });
        }
    }

    _openModal(video = null, type = "vk") {
        if (video){
            let htmlVideo = "";

            if (type === 'vk'){
                htmlVideo = `<iframe
                                        src="https://vkvideo.ru/video_ext.php?${video}&hd=4&autoplay=1"
                                        allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
                                        frameborder="0"
                                        allowfullscreen>
                                    </iframe>`;
            }
            if (type === 'youtube'){
                htmlVideo = `<iframe
                                        src="https://www.youtube.com/embed/${video}?autoplay=1&showinfo=0&rel=0"
                                        allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
                                        frameborder="0"
                                        allowfullscreen>
                                    </iframe>`;
            }

            const modalContent = document.getElementById('blockSwiperVideoSliderModal_content');
            modalContent.insertAdjacentHTML(
                'afterbegin',
                htmlVideo
            );
        }
    }

    _destroyModal(){
        $('#blockSwiperVideoSliderModal').on('hidden.bs.modal', (e) => {
            const modalContent = document.getElementById('blockSwiperVideoSliderModal_content');
            modalContent.innerHTML = "";
        });
    }

    init(){
        this._createSlider();
    }
}
